import React from 'react';
import axios from 'axios';
import '../App.css';
import { AddQuestions, fetchQuestionsCategory, baseApiUrl, fetchQuestions } from '../api/api';
import PageNavigation from './PageNavigation';
import LoaderComponent from './LoaderComponent';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Dropzone from 'react-dropzone';
import { BsUpload } from 'react-icons/bs';
import { store } from '../App';

const UploadTypeOptions = [{ id: 0, type: "Customer to Download and Re-upload" }];

class AddQuestion extends React.Component {
    constructor() {
        super();
        this.state = {
            question: '',
            question_type: '',
            category: '',
            free_text: '',
            suggested_answers: [''],
            error: '',
            disabled: true,
            is_mandatory: 'false',
            is_related: 'false',
            suggested_jump: [],
            relatedQuestions: [],
            uploadType: '',
            template_paths: '',
            parent_category_id: '',
            isLoading: false

        };
    }

    async componentDidMount() {
        this.setState({ isLoading: true });
        await fetchQuestionsCategory();
        const { id } = this.props.match.params;
        const currentUser = store.getState().loginData.user.token;
        if (id) {
            try {
                const response = await axios
                    .get(`${baseApiUrl}/questions/${id}/`, {
                        headers: {
                            Authorization: `Bearer ${currentUser}`
                        }
                    })
                    .then((response) => {
                        return response.data;
                    });

                const res = await fetchQuestions(response.category);

                this.setState({
                    question: response.question,
                    question_type: response.question_type,
                    category: response.category,
                    suggested_answers: response.suggested_answers,
                    suggested_jump: response.suggested_jump,
                    is_mandatory: response.is_mandatory ? response.is_mandatory : 'false',
                    is_related: response.is_related,
                    relatedQuestions: res.response,
                    parent_category_id: response.parent_category_id ? response.parent_category_id : response.category,
                    template_paths: response.template_paths,
                    uploadType: response.template_paths ? "0" : ''

                });
                this.setState({ isLoading: false });
            } catch (error) {
                console.log(error, 'error');
                this.setState({ isLoading: false });
            }
        } else {
            this.setState({});
            this.setState({ isLoading: false });
        }
    }

    handleJump = (i) => (e) => {
        let suggested_jump = [...this.state.suggested_jump];

        if (i >= 0) {
            suggested_jump[i] = e.target.value;
        } else {
            suggested_jump = e.target.value;
        }
        this.setState({
            suggested_jump
        });
    };

    handleText = (i) => (e) => {
        let suggested_answers = [...this.state.suggested_answers];
        suggested_answers[i] = e.target.value;

        this.setState({
            suggested_answers
        });
    };

    handleDelete = (i) => (e) => {
        e.preventDefault();
        let suggested_answers = [...this.state.suggested_answers.slice(0, i), ...this.state.suggested_answers.slice(i + 1)];
        this.setState({
            suggested_answers
        });
    };

    addQuestion = (e) => {
        e.preventDefault();
        let suggested_answers = this.state.suggested_answers.concat(['']);
        this.setState({
            suggested_answers
        });
    };
    addQues = async (e) => {
        e.preventDefault();
        const { id } = this.props.match.params;
        let formdata = new FormData();
        const data = {
            question: this.state.question,
            question_type: this.state.question_type,
            category: this.state.category,
            free_text: this.state.free_text,
            suggested_answers: this.state.suggested_answers,
            is_mandatory: this.state.is_mandatory?.toString(),
            is_related: this.state.is_related?.toString(),
            suggested_jump: this.state.suggested_jump,
            template_paths: this.state.template_paths
        };

        this.setState({ isLoading: true });
        Object.keys(data).forEach((item) =>
            (item === "template_paths" && data["template_paths"] !== '') ? formdata.append('template_paths', this.state.template_paths) :
                formdata.append(item, data[item]));
       
        try {
            const response = await AddQuestions(formdata, id);
            
            if (response.status === 'failed') {
                this.setState({
                    error: response.response.question
                });
            } else {
                toast.info(`Question ${id ? 'updated' : 'added'}  successfully.`, { position: toast.POSITION.TOP_CENTER, autoClose: 3000 });
                const res = await fetchQuestions(data.category);
                if (!id) {
                    this.setState({
                        question: "",
                        question_type: "",
                        category: this.state.category,
                        free_text: "",
                        suggested_answers: [""],
                        is_mandatory: false,
                        is_related: false,
                        suggested_jump: [],
                        template_paths: "",
                        relatedQuestions: res.response,
                        parent_category_id: this.state.parent_category_id ? this.state.parent_category_id : ""
                    })
                }
               this.setState({isLoading: false});
            }

        } catch (e) {
            this.setState({
                error: e.message.question,
                isLoading: false

            });
            return;
        }
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({
            [name]: value
        });
    };

    onRadioChange = async (e) => {
        const { name, value } = e.target;

        if (name === 'is_mandatory' || name === 'is_related') {
            this.setState({
                [name]: value === 'true' ? false : true
            });
        } else {
            this.setState({
                [name]: value
            });
        }

    };

    handleCategoryChange = async (e) => {
        const { name, value } = e.target;
        if (!value) {
            this.setState({
                category: '',
                parent_category_id: '',
                relatedQuestions: []
            });
            return;
        }
        let selectedValue;
        try {
            selectedValue = JSON.parse(value);
        } catch (err) {
            console.error("Invalid value");
            return;
        }

        const response = await fetchQuestions(selectedValue?.id);

        let final;
        if (selectedValue?.children?.length > 0) {
            final = {
                category: selectedValue?.children[0]?.id,
                parent_category_id: selectedValue?.children[0]?.parent_category_id
            };
        } else {
            final = {
                category: selectedValue?.id,
                parent_category_id: selectedValue?.parent_category_id
            };

        }

        this.setState({
            ...final,
            relatedQuestions: response?.response
        });
    };

    handleUploadType = (event) => {
        const { name, value } = event.target;
        this.setState({ uploadType: value });
        if (!value) {
            this.setState({ template_paths: '' });
        }

    }

    handleUploadFile = (acceptedFiles) => {
        this.setState({ template_paths: acceptedFiles[0] })
    }

    subCategoryDisplay = () => {
        const { questionscategoryList } = this.props;
        const { category, parent_category_id } = this.state;
        const { id } = this.props.match.params;
        if (!questionscategoryList?.response) return null;

        return (
            questionscategoryList?.response.filter((data) => data.id?.toString() === category?.toString() || data.id?.toString() === parent_category_id?.toString())
                .map((data) => {

                    if (data?.children?.length > 0) {
                        let defaultSelect = !parent_category_id ? null : category;

                        return (
                            <div className="col-sm-5">
                                <legend className="col-form-label col-sm-4 pt-0  font-weight-bold">Sub category:</legend>
                                <select name="category" className="form-control" id="FormControlSelect1"
                                    onChange={(e) => this.handleCategoryChange(e)}
                                >
                                    <option value="">Select sub category</option>
                                    {data?.children.map((item, i) => (
                                        <option key={i} value={JSON.stringify(item)}
                                            selected={item.id?.toString() === defaultSelect?.toString()}
                                        >
                                            {item.title}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )
                    }
                })
        )


    };

    render() {
        const { id } = this.props.match.params;
        const { isLoading } = this.state;
        const { questionscategoryList } = this.props;
        const { relatedQuestions, question_type, uploadType, template_paths, parent_category_id, category } = this.state;
        let customerList = questionscategoryList ? questionscategoryList?.response : [];
        let backPath = id ? "/admin/configure/questions" : "/admin/configure";
        let headerName = id ? 'Edit' : 'Add New';
        toast.configure();
         
        return (
            <div className="col-sm-12 my-2">
                <div className="card rounded shadow-sm">
                    <PageNavigation {...this.props} header={`${headerName} Question`} path={backPath} category={category} parentId={parent_category_id} />
                    <LoaderComponent isLoading={isLoading} />
                    <div className="card-body">
                        <div className="container-fluid">
                            <form className="">
                                <div className="row"><h6 className='p-3' style={{ color: "#8284e5" }}>Fill in the details below to create or update a question:</h6></div>
                                {this.state.error && <div className="col text-center text-danger mb-3 font-weight-bold">{this.state.error}</div>}
                                <fieldset className="form-group">
                                    <div className="row">
                                        <div className="col-sm-5">
                                            <legend className="col-form-label col-sm-4 pt-0  font-weight-bold">Category:</legend>
                                            <select name="category" className="form-control" id="FormControlSelect1"
                                                onChange={(e) => this.handleCategoryChange(e)}
                                            >
                                                <option value="">Select Category</option>
                                                {customerList.map((data, i) => (
                                                    <option key={i} value={JSON.stringify(data)}
                                                        selected={data.id === parent_category_id || data.id === category}
                                                    >
                                                        {data.title}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        {this.subCategoryDisplay()}
                                    </div>
                                </fieldset>
                                {category !== "" && (
                                    <React.Fragment>
                                        <div className="form-group row">
                                            <label className="col-sm-2 col-form-label font-weight-bold ">Question:</label>
                                            <div className="col-sm-5">
                                                <input type="text" onChange={this.handleChange} value={this.state.question} name="question" className="form-control " id="inputEmail3" required />
                                            </div>
                                        </div>
                                        <fieldset className="form-group">
                                            <div className="row">
                                                <legend className="col-form-label col-sm-2 font-weight-bold">Answer type:</legend>
                                                <div className="col-sm-10">
                                                    <div className="form-check form-check-inline">
                                                        <input onChange={this.onRadioChange} className="form-check-input" name="question_type" type="radio" checked={this.state.question_type === 'SELECT'} disabled={id && this.state.question_type !== 'SELECT' ? true : false} value="SELECT" required />
                                                        <label className="form-check-label">Drop Down</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input onChange={this.onRadioChange} className="form-check-input" name="question_type" checked={this.state.question_type === 'TEXT'} type="radio" value="TEXT" disabled={id && this.state.question_type !== 'TEXT' ? true : false} required />
                                                        <label className="form-check-label">Text</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input onChange={this.onRadioChange} className="form-check-input" name="question_type" checked={this.state.question_type === 'CHECKBOX'} type="radio" value="CHECKBOX" disabled={id && this.state.question_type !== 'CHECKBOX' ? true : false} required />
                                                        <label className="form-check-label">Checkbox</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input onChange={this.onRadioChange} className="form-check-input" name="question_type" checked={this.state.question_type === 'RADIO'} type="radio" value="RADIO" disabled={id && this.state.question_type !== 'RADIO' ? true : false} required />
                                                        <label className="form-check-label">Radio</label>
                                                    </div>
                                                    <div className="form-check form-check-inline">
                                                        <input onChange={this.onRadioChange} className="form-check-input" name="question_type" type="radio" value="FILE" disabled={id && this.state.question_type !== 'FILE' ? true : false} checked={this.state.question_type === 'FILE'} required />
                                                        <label className="form-check-label">Upload File</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </fieldset>
                                        {question_type === "FILE" && (
                                            <fieldset className="form-group">
                                                <div className="row">
                                                    <legend className="col-form-label col-sm-2 font-weight-bold">Upload type:</legend>
                                                    <div className="col-sm-4">
                                                        <div className="form-check form-check-inline">
                                                            <select name="uploadType" className="form-control" id="exampleFormControlSelect1" onChange={(e) => this.handleUploadType(e)}>
                                                                <option value="">Select</option>
                                                                {UploadTypeOptions
                                                                    .map((item, i) => (
                                                                        <option key={i} value={item.id} selected={item.id?.toString() === uploadType?.toString()}>
                                                                            {item.type}
                                                                        </option>
                                                                    ))}
                                                            </select>
                                                        </div>
                                                    </div>
                                                    {template_paths && (
                                                        <div className="col-sm-2">
                                                            <label className="form-check-label text-primary" style={{ wordBreak: "break-all" }}>{template_paths.name ? template_paths.name : template_paths}</label>
                                                        </div>
                                                    )}
                                                    <div className="col-sm-2">
                                                        {uploadType === "0" && (
                                                            <Dropzone onDrop={this.handleUploadFile} accept="image/*" maxFiles={10}>
                                                                {({ getRootProps, getInputProps }) => (
                                                                    <div {...getRootProps()} className="dropzone d-flex justify-content-center">
                                                                        <input {...getInputProps()} />
                                                                        <button type="button" className="btn btn-primary font-weight-bold btn-block report_button" data-toggle="tooltip" data-placement="top" >
                                                                            <BsUpload /> &nbsp;
                                                                            <label className="form-check-label">Upload</label>
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </Dropzone>
                                                        )}
                                                    </div>
                                                </div>
                                            </fieldset>

                                        )}


                                        {this.state.question_type === 'FILE' || this.state.question_type === 'TEXT' || this.state.question_type === ''
                                            ? ''
                                            : this.state.suggested_answers.map((question, index) => (
                                                <div key={index} className="form-group row">
                                                    <label className="col-sm-2 col-form-label font-weight-bold">
                                                        Answer {index + 1}:{question.answer}
                                                    </label>
                                                    <div className="col-sm-3">
                                                        <input type="text" onChange={this.handleText(index)} value={question} className="form-control" required />
                                                        {index !== 0 && (
                                                            <div
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '1px',
                                                                    right: '-0px',
                                                                    width: '25px',
                                                                    height: '25px',
                                                                    border: '1px solid #d9534f',
                                                                    backgroundColor: '#d9534f',
                                                                    borderRadius: '200px',
                                                                    textAlign: 'center',
                                                                    color: 'white'
                                                                }}
                                                                className="font-text-bold text-center "
                                                                onClick={this.handleDelete(index)}
                                                            >
                                                                <b>X</b>
                                                            </div>
                                                        )}
                                                        {this.state.question_type === 'FILE' || this.state.question_type === 'TEXT'
                                                            ? ''
                                                            : index === this.state.suggested_answers.length - 1 && (
                                                                <div
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: '1px',
                                                                        right: '-30px',
                                                                        width: '25px',
                                                                        height: '25px',
                                                                        textAlign: 'center',
                                                                        color: '#000000'
                                                                    }}
                                                                    className="font-text-bold text-center "
                                                                    onClick={this.addQuestion}
                                                                >
                                                                    <i className="fa fa-plus" style={{ fontSize: '36px' }}></i>
                                                                </div>
                                                            )}
                                                    </div>

                                                    <>
                                                        <label className="col-sm-1 col-form-label font-weight-bold ml-5">Jump to:</label>
                                                        <div className="col-sm-3">
                                                            <select name="jumpto" className="form-control" id="exampleFormControlSelect1" data-name="suggested_jump" onChange={this.handleJump(index)}>
                                                                <option value="">Select</option>
                                                                {relatedQuestions
                                                                    .filter((sec, key) => (sec.is_related === true && this.state.question !== sec.question))
                                                                    .map((ques, i) => (
                                                                        <option key={i} value={ques.question} selected={ques.question === this.state.suggested_jump[index]}>
                                                                            {ques.question}
                                                                        </option>
                                                                    ))}
                                                            </select>
                                                        </div>
                                                    </>
                                                </div>
                                            ))}
                                        {this.state.question_type === 'TEXT' ? (
                                            <div className="form-group row">
                                                <label className="col-sm-2 col-form-label font-weight-bold">Jump to:</label>
                                                <div className="col-sm-3">
                                                    <select name="jumpto" className="form-control" id="exampleFormControlSelect1" data-name="suggested_jump" onChange={this.handleJump()}>
                                                        <option value="">Select</option>
                                                        {relatedQuestions.map(
                                                            (sec, key) =>
                                                                (sec.is_related === true && this.state.question !== sec.question) && (
                                                                    <option key={key} value={sec.question} selected={sec.question === this.state.suggested_jump}>
                                                                        {sec.question}
                                                                    </option>
                                                                )
                                                        )}
                                                    </select>
                                                </div>
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                        <div className="form-check form-check">
                                            <input type="checkbox" className="form-check-input" name="is_related" value={this.state.is_related} checked={this.state.is_related === true} onChange={this.onRadioChange} />
                                            <label className="form-check-label font-weight-bold">Related</label>
                                        </div>
                                        <div className="form-check form-check">
                                            <input type="checkbox" className="form-check-input" name="is_mandatory" value={this.state.is_mandatory} checked={this.state.is_mandatory === true} onChange={this.onRadioChange} />
                                            <label className="form-check-label font-weight-bold">Mandatory</label>
                                        </div>
                                        <div className="form-group">
                                            <div className="d-flex justify-content-center mb-3 mt-3">
                                                <button type="button" className="col-sm-2 btn btn-primary btn-block font-weight-bold" onClick={(e) => this.addQues(e)}>
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                )}

                            </form>
                        </div>

                    </div>
                </div>
            </div>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        questionscategoryList: state.categoryList.questionscategoryList
    };
};
export default connect(mapStateToProps)(AddQuestion);
